import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Warning, Sparkle } from "@phosphor-icons/react";

export default function TrialBanner() {
  const { user } = useAuth();
  const [forcedExpired, setForcedExpired] = useState(false);

  useEffect(() => {
    const onExpired = () => setForcedExpired(true);
    window.addEventListener("billing-expired", onExpired);
    return () => window.removeEventListener("billing-expired", onExpired);
  }, []);

  const org = user && typeof user === "object" ? user.org : null;
  if (!org || org.is_default) return null;

  const state = forcedExpired ? "expired" : org.billing_state;
  if (state === "ok") return null;

  if (state === "expired") {
    return (
      <div data-testid="billing-banner-expired" className="w-full bg-red-600 text-white px-4 py-2 flex items-center justify-center gap-3 text-sm font-semibold">
        <Warning weight="fill" className="w-4 h-4" />
        <span>Your trial / subscription has expired. Renew to keep using the modules.</span>
        <Link to="/pricing" data-testid="billing-banner-cta" className="underline font-bold">Choose a plan</Link>
      </div>
    );
  }
  // trial
  return (
    <div data-testid="billing-banner-trial" className="w-full bg-primary text-primary-foreground px-4 py-2 flex items-center justify-center gap-3 text-sm font-semibold">
      <Sparkle weight="fill" className="w-4 h-4" />
      <span>Free trial — {org.trial_days_left} day{org.trial_days_left === 1 ? "" : "s"} left.</span>
      <Link to="/pricing" data-testid="billing-banner-cta" className="underline font-bold">Upgrade now</Link>
    </div>
  );
}
